module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showControlBar) ? _c('div', {
    staticClass: "vgt-global-search vgt-clearfix"
  }, [_c('div', {
    staticClass: "vgt-global-search__input vgt-pull-left"
  }, [(_vm.searchEnabled) ? _c('span', {
    staticClass: "input__icon"
  }, [_c('div', {
    staticClass: "magnifying-glass"
  })]) : _vm._e(), _vm._v(" "), (_vm.searchEnabled) ? _c('input', {
    staticClass: "vgt-input vgt-pull-left",
    attrs: {
      "type": "text",
      "placeholder": _vm.globalSearchPlaceholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.entered($event.target.value)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vgt-global-search__actions vgt-pull-right"
  }, [_vm._t("internal-table-actions")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a8b6454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-good-table/src/components/VgtGlobalSearch.vue
// module id = 993
// module chunks = 1